import React from "react";
import { Checkbox, Modal } from "antd";

export const MapPopUpConfigurations = (props) => {
    return (
        <Modal title="Map Configurations" open={props.isModalOpen} onOk={props.handleOk} onCancel={props.handleCancel} style={{ top: 400 }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'center' }}>
                <Checkbox onChange={() => console.log('Traffic selected')}>Show Traffic</Checkbox>
                <Checkbox onChange={() => console.log('3D selected')}>Show 3D</Checkbox>
            </div>
        </Modal>
    )
};